
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

interface NotificationFiltersProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
}

const NotificationFilters: React.FC<NotificationFiltersProps> = ({
  activeTab,
  setActiveTab,
  searchTerm,
  setSearchTerm
}) => {
  return (
    <Tabs
      defaultValue={activeTab}
      value={activeTab}
      onValueChange={setActiveTab}
    >
      <div className="bg-white p-3 rounded-lg shadow-[inset_0_2px_4px_rgba(0,0,0,0.05),inset_0_-2px_4px_rgba(0,0,0,0.05),inset_2px_0_4px_rgba(0,0,0,0.05),inset_-2px_0_4px_rgba(0,0,0,0.05)]">
        <div className="flex items-center justify-between gap-4">
          <TabsList className="h-auto bg-transparent p-0 justify-start">
            <div className="flex items-center gap-1 flex-wrap justify-start">
              <TabsTrigger
                value="all"
                className="px-3 py-1.5 text-sm font-medium rounded-md transition-all data-[state=active]:bg-white data-[state=active]:text-black data-[state=active]:shadow-md data-[state=active]:border data-[state=active]:border-gray-200 data-[state=inactive]:text-[#737373] data-[state=inactive]:font-medium data-[state=inactive]:bg-transparent"
              >
                All
              </TabsTrigger>
              <TabsTrigger
                value="unopened"
                className="px-3 py-1.5 text-sm font-medium rounded-md transition-all data-[state=active]:bg-white data-[state=active]:text-black data-[state=active]:shadow-md data-[state=active]:border data-[state=active]:border-gray-200 data-[state=inactive]:text-[#737373] data-[state=inactive]:font-medium data-[state=inactive]:bg-transparent"
              >
                Unopened
              </TabsTrigger>
            </div>
          </TabsList>
          <div className="relative flex-shrink-0 hidden md:block">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
            <Input
              type="text"
              placeholder="Search notifications"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-9 w-64 h-9"
            />
          </div>
        </div>
      </div>
    </Tabs>
  );
};

export default NotificationFilters;
